import React from 'react';
import { observer } from 'mobx-react';

import { Store } from 'pages/calendar/store';

import { CalendarPageYearMonth } from './components/CalendarPageYearMonth';

import './styles.scss';

export const CalendarPageYear = observer(function CalendarPageYear() {
    const date = Store.date.startOf('year');

    return (
        <div className='calendar-page-year'>
            {Array(12)
                .fill(null)
                .map((_, index) => {
                    return (
                        <CalendarPageYearMonth key={index} date={date.add(index, 'month')}/>
                    );
                })}
        </div>
    );
});
